(function( $ ) {
  $( document ).ready( function() {
    $body = $('body');

    // Check for terms and conditions on the default cart page (i.e. non ajax cart)
    $body.on('submit', 'form.cart', function (evt) {
      $terms = $(this).find('.terms-agree');
      $warning = $(this).find('.terms-warning');

      $warning.hide();

      // Check that terms and conditions has been reviewed
      if ( ! $terms.is(":checked") ) {
        evt.preventDefault();
        $warning.show();
      }
    });

    // Terms and conditions modal
    $body.on('click', '.terms-link', function() {
      $('.terms-and-conditions-container').show();
    });

    $body.on('click', '.terms-and-conditions-container .btn-close', function() {
      $('.terms-and-conditions-container').hide();
    });
  });
})(jQuery);